import {
    ModuleWithProviders,
    NgModule,
    inject,
    provideAppInitializer,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { EvaderDirective } from './directives/evader.directive';
import { EasterService } from './easter.service';
import { EasterAlertComponent } from './components/easter-alert/easter-alert.component';

@NgModule({
    imports: [CommonModule],
    declarations: [EvaderDirective, EasterAlertComponent],
    exports: [EvaderDirective, EasterAlertComponent],
})
export class EasterModule {
    public static forRoot(): ModuleWithProviders<EasterModule> {
        return {
            ngModule: EasterModule,
            providers: [
                EasterService,
                provideAppInitializer(() => inject(EasterService).start()),
            ],
        };
    }
}
